/**
 * FAQ Page
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle, MessageCircle } from 'lucide-react';

const FAQ_CATEGORIES = [
  {
    title: 'عن خالتي هيلة',
    icon: '👩‍🦳',
    questions: [
      {
        q: 'وش هي خالتي هيلة؟',
        a: 'خالتي هيلة هي منصة سعودية للتعارف بهدف الزواج، تستخدم الذكاء الاصطناعي عشان تلاقي لك الشخص المناسب. سميناها "خالتي هيلة" لأنها مثل الخالة اللي تعرف الناس وتوفّق بينهم، بس بتقنية ذكية!'
      },
      {
        q: 'هل المنصة مجانية؟',
        a: 'نعم! حالياً المنصة مجانية بالكامل. خالتي هيلة تبي تشوفكم مرتبطين بس 😊'
      },
      {
        q: 'هل المنصة للسعوديين فقط؟',
        a: 'نعم، حالياً المنصة مخصصة للسعوديين والسعوديات فقط. نفهم ثقافتنا وعاداتنا ونحترمها.'
      },
      {
        q: 'كيف يشتغل الذكاء الاصطناعي؟',
        a: 'الذكاء الاصطناعي يحلل إجاباتك على الأسئلة، يفهم شخصيتك وقيمك وتفضيلاتك، وبعدين يبحث عن الشخص اللي يناسبك. كمان يقترح لك مواضيع للمحادثة بناءً على اهتماماتكم المشتركة.'
      }
    ]
  },
  {
    title: 'التسجيل والحساب',
    icon: '📝',
    questions: [
      {
        q: 'كيف أسجّل؟',
        a: 'التسجيل سهل! ادخل إيميلك واختر كلمة مرور، بعدها راح تجيك رسالة تأكيد. بعد التأكيد، خالتي هيلة راح تسألك أسئلة عشان تتعرف عليك.'
      },
      {
        q: 'وش الأسئلة اللي راح تُسأل؟',
        a: 'أسئلة عن: معلوماتك الأساسية، شخصيتك، التزامك الديني، نمط حياتك، وتفضيلاتك في الشريك. كل الأسئلة مصممة عشان نلاقي لك أفضل توافق.'
      },
      {
        q: 'هل أقدر أعدّل إجاباتي؟',
        a: 'حالياً لا، لكن هالميزة قريباً إن شاء الله.'
      },
      {
        q: 'كيف أحذف حسابي؟',
        a: 'تواصل معنا على support@khaltihaila.com وراح نحذف حسابك وكل بياناتك خلال 24 ساعة.'
      }
    ]
  },
  {
    title: 'التوافق والمطابقة',
    icon: '💕',
    questions: [
      {
        q: 'كيف يتم اختيار التوافق؟',
        a: 'الذكاء الاصطناعي يحلل إجاباتك ويقارنها مع إجابات المستخدمين الآخرين. يبحث عن التوافق في: القيم، الشخصية، نمط الحياة، والتفضيلات. بعدين يرشح لك الشخص الأنسب.'
      },
      {
        q: 'ليش توافق واحد بس في كل مرة؟',
        a: 'لأننا نؤمن أن التعارف الجاد يحتاج تركيز. بدل ما تتشتت بين كثير ناس، خالتي هيلة تخليك تركز على شخص واحد وتتعرف عليه صح.'
      },
      {
        q: 'وش يصير لو ما عجبني التوافق؟',
        a: 'عادي! ترفض وتنتظر 48 ساعة (فترة استراحة)، وبعدها خالتي هيلة تجيب لك توافق جديد.'
      },
      {
        q: 'وش معنى نسبة التوافق؟',
        a: 'نسبة التوافق تعكس قد إيش أنتو متشابهين في القيم والاهتمامات ونمط الحياة. كل ما النسبة أعلى، كل ما التوافق أقوى.'
      }
    ]
  },
  {
    title: 'المحادثات',
    icon: '💬',
    questions: [
      {
        q: 'كم مدة المحادثة؟',
        a: '7 أيام. وقت كافي تتعرفون على بعض وتقررون إذا تبون تكملون أو لا.'
      },
      {
        q: 'أقدر أمدد المحادثة؟',
        a: 'نعم! تقدر تمدد حتى 4 مرات (كل مرة 7 أيام). يعني الحد الأقصى 35 يوم.'
      },
      {
        q: 'أقدر أنسحب من المحادثة؟',
        a: 'طبعاً! بأي لحظة. خالتي هيلة راح ترسل رسالة لطيفة للطرف الثاني وما راح يعرف السبب.'
      },
      {
        q: 'وش يصير بعد الانسحاب؟',
        a: 'بعد الانسحاب فيه فترة استراحة 48 ساعة، وبعدها تقدر تشوف توافقات جديدة. والشخص اللي انسحبت منه ما راح يطلع لك مرة ثانية.'
      },
      {
        q: 'وش اقتراحات المواضيع؟',
        a: 'خالتي هيلة تقترح لك مواضيع للمحادثة بناءً على اهتماماتكم المشتركة. مثلاً: "كلكم تحبون السفر، وش أحلى مكان زرته؟"'
      }
    ]
  },
  {
    title: 'مشاركة التواصل',
    icon: '📱',
    questions: [
      {
        q: 'متى أقدر أشارك معلومات التواصل؟',
        a: 'في أي وقت خلال المحادثة أو في نهايتها. أنت تختار متى وكيف تشارك.'
      },
      {
        q: 'وش الخيارات المتاحة للمشاركة؟',
        a: 'تقدر تشارك: رقم الجوال فقط، الانستقرام فقط، كل البيانات، أو تتفقون تشاركون داخل المحادثة بأنفسكم.'
      },
      {
        q: 'هل المشاركة إجبارية؟',
        a: 'لا! القرار بيدك 100%. تقدر تنسحب بدون ما تشارك أي شي.'
      }
    ]
  },
  {
    title: 'الخصوصية والأمان',
    icon: '🔒',
    questions: [
      {
        q: 'هل بياناتي آمنة؟',
        a: 'نعم! نستخدم تشفير AES-256 (نفس اللي تستخدمه البنوك). بياناتك الحساسة مثل رقم الجوال واسم العائلة مشفرة ولا يطّلع عليها أحد.'
      },
      {
        q: 'مين يشوف بياناتي؟',
        a: 'فقط المعلومات اللي تسمح بعرضها للتوافقات. بيانات مثل رقم الجوال واسم العائلة لا تُعرض إلا إذا أنت شاركتها.'
      },
      {
        q: 'هل تبيعون بياناتي؟',
        a: 'أبداً! بياناتك ملكك ولا نبيعها ولا نشاركها مع أي طرف ثالث.'
      },
      {
        q: 'وش أسوي لو واجهت شخص مزعج؟',
        a: 'تقدر تبلّغ عنه أو تحظره. إذا بلّغت، راح نراجع الحالة ونتخذ الإجراء المناسب.'
      }
    ]
  }
];

export default function FAQ() {
  const [openCategory, setOpenCategory] = useState(0);
  const [openQuestion, setOpenQuestion] = useState(null);

  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="bg-gradient-to-br from-rose-50 via-purple-50 to-pink-50 py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <HelpCircle className="w-16 h-16 text-purple-600 mx-auto mb-4" />
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            الأسئلة الشائعة
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            كل اللي تحتاج تعرفه عن خالتي هيلة
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          {/* Category Tabs - Mobile Scroll */}
          <div className="flex gap-2 overflow-x-auto pb-4 mb-8 scrollbar-hide">
            {FAQ_CATEGORIES.map((cat, index) => (
              <button
                key={index}
                onClick={() => { setOpenCategory(index); setOpenQuestion(null); }}
                className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all ${
                  openCategory === index
                    ? 'bg-gradient-to-r from-rose-500 to-purple-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <span>{cat.icon}</span>
                <span className="text-sm font-medium">{cat.title}</span>
              </button>
            ))}
          </div>

          {/* Questions */}
          <div className="space-y-3">
            {FAQ_CATEGORIES[openCategory].questions.map((item, index) => (
              <div 
                key={index}
                className="border border-gray-200 rounded-2xl overflow-hidden"
              >
                <button
                  onClick={() => setOpenQuestion(openQuestion === index ? null : index)}
                  className="w-full flex items-center justify-between p-4 md:p-6 text-right hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 pr-4">{item.q}</span>
                  {openQuestion === index ? (
                    <ChevronUp className="w-5 h-5 text-rose-500 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  )}
                </button>
                {openQuestion === index && (
                  <div className="px-4 md:px-6 pb-4 md:pb-6">
                    <p className="text-gray-600 leading-relaxed bg-rose-50/50 p-4 rounded-xl">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-rose-50">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <MessageCircle className="w-12 h-12 text-rose-500 mx-auto mb-4" />
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            ما لقيت جوابك؟
          </h2>
          <p className="text-gray-600 mb-6">
            تواصل معنا وراح نرد عليك بأسرع وقت
          </p>
          <a
            href="#/contact"
            className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-rose-500 to-purple-600 text-white rounded-full font-semibold hover:shadow-lg transition-all"
          >
            تواصل معنا
          </a>
        </div>
      </section>
    </div>
  );
}
